const getAllUser = `getAllUser{id, username, email, enabled, password, last_login, roles,}`;

export default getAllUser;
